import React from "react";

const DischargeSummary = ({ patient, onFinalize }) => {
  return (
    <div className="p-6 bg-white shadow rounded-lg">
      <h1 className="text-2xl font-bold mb-6 text-center">Discharge Summary</h1>

      {/* Hospital Information */}
      <div className="mb-6 border-b pb-4">
        <h2 className="text-lg font-semibold mb-2">Hospital Information</h2>
        <p>
          <strong>Name:</strong> XYZ Multispeciality Hospital
        </p>
        <p>
          <strong>Address:</strong> 123 Hospital Road, New Delhi, India
        </p>
        <p>
          <strong>Contact:</strong> +91-9876543210 | info@xyzhospital.com
        </p>
        <p>
          <strong>Registration Number:</strong> NABH-XYZ-2023
        </p>
      </div>

      {/* Patient Information */}
      <div className="mb-6 border-b pb-4">
        <h2 className="text-lg font-semibold mb-2">Patient Information</h2>
        <p>
          <strong>Name:</strong> {patient.name}
        </p>
        <p>
          <strong>Age:</strong> {patient.age}
        </p>
        <p>
          <strong>Gender:</strong> {patient.gender}
        </p>
        <p>
          <strong>Patient ID:</strong> {patient.id}
        </p>
        <p>
          <strong>Admission Date:</strong> {patient.admissionDate}
        </p>
        <p>
          <strong>Discharge Date:</strong> {patient.dischargeDate}
        </p>
        <p>
          <strong>Consultant Doctor:</strong> {patient.doctor}
        </p>
        <p>
          <strong>Ward/Bed:</strong> {patient.ward} /{" "}
          {patient.bed || "Not Assigned"}
        </p>
      </div>

      {/* Admission & Medical History */}
      <div className="mb-6 border-b pb-4">
        <h2 className="text-lg font-semibold mb-2">
          Admission & Medical History
        </h2>
        <p>
          <strong>Reason for Admission:</strong>{" "}
          {patient.reasonForAdmission || "Not Provided"}
        </p>
        <p>
          <strong>Past Medical History:</strong>{" "}
          {patient.medicalHistory || "Not Provided"}
        </p>
        <p>
          <strong>Allergies:</strong> {patient.allergies || "None"}
        </p>
      </div>

      {/* Diagnosis and Treatment Summary */}
      <div className="mb-6 border-b pb-4">
        <h2 className="text-lg font-semibold mb-2">
          Diagnosis and Treatment Summary
        </h2>
        <p>
          <strong>Provisional Diagnosis:</strong>{" "}
          {patient.provisionalDiagnosis || "Not Provided"}
        </p>
        <p>
          <strong>Final Diagnosis:</strong>{" "}
          {patient.finalDiagnosis || "Not Provided"}
        </p>
        <p>
          <strong>Treatment Provided:</strong>{" "}
          {patient.treatmentSummary || "Not Provided"}
        </p>
        <p>
          <strong>Procedures Conducted:</strong>{" "}
          {patient.procedures ? patient.procedures.join(", ") : "None"}
        </p>
      </div>

      {/* Medications and Follow-Up Instructions */}
      <div className="mb-6 border-b pb-4">
        <h2 className="text-lg font-semibold mb-2">
          Medications and Follow-Up Instructions
        </h2>
        <p>
          <strong>Medications on Discharge:</strong>{" "}
          {patient.medications ? patient.medications.join(", ") : "None"}
        </p>
        <p>
          <strong>Follow-Up Instructions:</strong>{" "}
          {patient.followUpInstructions || "No Instructions Provided"}
        </p>
        <p>
          <strong>Next Appointment:</strong>{" "}
          {patient.nextAppointment || "Not Scheduled"}
        </p>
      </div>

      {/* Discharge Condition */}
      <div className="mb-6 border-b pb-4">
        <h2 className="text-lg font-semibold mb-2">Discharge Condition</h2>
        <p>
          <strong>Condition on Discharge:</strong>{" "}
          {patient.dischargeCondition || "Stable"}
        </p>
        <p>
          <strong>Discharge Summary Notes:</strong> {patient.notes || "None"}
        </p>
      </div>

      {/* Emergency Contact */}
      <div className="mb-6 border-b pb-4">
        <h2 className="text-lg font-semibold mb-2">Emergency Contact</h2>
        <p>
          <strong>Contact Person:</strong>{" "}
          {patient.emergencyContact.name || "Not Provided"}
        </p>
        <p>
          <strong>Relationship:</strong>{" "}
          {patient.emergencyContact.relationship || "Not Provided"}
        </p>
        <p>
          <strong>Contact Number:</strong>{" "}
          {patient.emergencyContact.phone || "Not Provided"}
        </p>
      </div>

      {/* Footer and Legal Disclaimer */}
      <div className="text-sm text-gray-600 mt-4">
        <p>
          <em>
            Disclaimer: This document is prepared in accordance with NABH
            guidelines and is valid for all insurance claims and medical
            records.
          </em>
        </p>
        <p>
          <strong>Signature of Doctor:</strong> ___________________
        </p>
        <p>
          <strong>Signature of Patient/Guardian:</strong> ___________________
        </p>
      </div>
    </div>
  );
};

export default DischargeSummary;
